import "@/App.css";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Landing />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
